import CustomButton from '../CustomElements/CustomButton';
import Accordeon from '../CustomElements/Accordeon';
import { useMemo } from 'react';
import { getAdminConfig } from './entitiesConfig';

/**
 * Компонент для отображения кнопок выбора сущностей (дороги, дирекции и т.д.)
 * Использует конфигурацию из entitiesConfig и отображает одну кнопку на каждую сущность.
 *
 * @param {string} selectedEntity - текущая выбранная сущность
 * @param {function} onSelectEntity - функция для изменения выбранной сущности
 */
function EntitySelector({ selectedEntity, onSelectEntity, t }) {
  const entitiesConfig = useMemo(() => getAdminConfig(t), [t]);
  // Получаем все ключи сущностей из конфигурационного объекта
  const entityKeys = Object.keys(entitiesConfig);
  return (
    <Accordeon header={t?.management} hideAbove={1650} qParamName="admin-data-panel">
      {entityKeys.map((entityKey) => {
        const isSelected = selectedEntity === entityKey;
        return (
          <CustomButton
            key={entityKey}
            className={`admin-buttons ${isSelected ? 'selected-button' : ''}`}
            text={entitiesConfig[entityKey].label}
            color={isSelected ? 'var(--sadr-success)' : 'white'}
            colorText={isSelected ? 'white' : 'var(--sadr-text-color)'}
            width="94%"
            onClick={() => {
              onSelectEntity(entityKey);
            }}
          />
        );
      })}
    </Accordeon>
  );
}

export default EntitySelector;
